/** leads/LeadsScreen.tsx — 모듈 셸 (venture 모듈 동일 레이아웃: 다크 사이드바 + 상단바 + 카드)
 *  영업 DB 5유형 재편 (지도사 확정 2026-07-17): 경정청구 파이프라인 3화면 + 인증 만료 임박 3종 + 업력 3년 */
import React, { useCallback, useState } from 'react';
import './leads.css';
import LeadAdminPage from './LeadAdminPage';
import LeadCandidatePage from './LeadCandidatePage';
import NightlyToggle from './NightlyToggle';
import FlowHelp from './FlowHelp';
import CapitalPage from './CapitalPage';
import CertExpiryPage from './CertExpiryPage';
import LeadFpPortalPage from './LeadFpPortalPage';
import StartupTaxcutPage from './StartupTaxcutPage';
import NewCorpPage from './NewCorpPage';

interface Props { onBack: () => void }

type ViewKey = 'candidates' | 'capital' | 'leads' | 'exp_venture' | 'exp_mainbiz' | 'exp_innobiz' | 'taxcut3y' | 'new_corps' | 'fp_portals';
interface MenuItem { key: ViewKey; icon: string; label: string; title: string; desc: string }

const GROUPS: { name: string; items: MenuItem[] }[] = [
  {
    name: '경정청구 (벤처투자)',
    items: [
      { key: 'candidates', icon: '🗂', label: '벤처기업', title: '🗂 영업 DB — 벤처기업', desc: '중기부 벤처기업명단 · 투자(설립·증자) 후 2년 안이 유효기간과 겹치면 대상 (§16 적용연도 선택)' },
      { key: 'capital', icon: '💰', label: '증자 업체', title: '💰 영업 DB — 증자 업체', desc: '자본금 증자 명단 업로드 → 벤처기업과 자동 대조 (교집합 = 경정청구 대상)' },
      { key: 'leads', icon: '📋', label: '경정청구 대상', title: '📋 영업 DB — 경정청구 대상', desc: '자동 대조·승격·직접 등록으로 확정된 DB · FP 배정부터 성공 전환까지' },
    ],
  },
  {
    name: '인증 만료 임박',
    items: [
      { key: 'exp_venture', icon: '⏰', label: '벤처 만료', title: '⏰ 영업 DB — 벤처 인증 만료 임박', desc: '유효종료 D-day 임박순 · 벤처확인 갱신 컨설팅 영업 (기존 벤처기업 명단 재활용)' },
      { key: 'exp_mainbiz', icon: '🏭', label: '메인비즈 만료', title: '🏭 영업 DB — 메인비즈 만료 임박', desc: '경영혁신형(메인비즈) 확인서 만료 임박 · 갱신 컨설팅 영업' },
      { key: 'exp_innobiz', icon: '🔬', label: '이노비즈 만료', title: '🔬 영업 DB — 이노비즈 만료 임박', desc: '기술혁신형(이노비즈) 확인서 만료 임박 · 갱신 컨설팅 영업' },
    ],
  },
  {
    // 신규법인 리스트 (2026-10-17 지도사) — 신설법인 명단 · 벤처확인 권유(설립 출자 소득공제) DM · 배정
    name: '신규법인',
    items: [
      { key: 'new_corps', icon: '🌱', label: '신규법인 리스트 (24, 25)', title: '🌱 영업 DB — 신규법인 리스트 (24, 25)', desc: '신설법인 명단 · 벤처 여부(중소벤처24) · 벤처확인 기한 안에 받으면 설립 출자금 소득공제 → DM · 배정' },
    ],
  },
  {
    name: '세액감면',
    items: [
      { key: 'taxcut3y', icon: '🎂', label: '업력 3년 임박', title: '🎂 영업 DB — 업력 3년 도래 임박', desc: '벤처 미확인 신설법인 · 설립 3년 내 벤처확인 시 창업벤처 세액감면(조특법 §6) — 포괄양수도 전환 제외 스크리닝' },
    ],
  },
  {
    name: '리드 포털',
    items: [
      { key: 'fp_portals', icon: '👥', label: '리드 포털', title: '👥 영업 DB — 리드 포털 (FP·WM)', desc: '배정 대상(FP·WM)이 보는 포털을 그대로 열어 확인 · 정보 수정(전 모듈 반영) · 링크 복사·문자 발송 · FP 신규등록' },
    ],
  },
];
const ALL_ITEMS = GROUPS.flatMap((g) => g.items);

export default function LeadsScreen({ onBack }: Props) {
  const [view, setView] = useState<ViewKey>('candidates');
  const [toast, setToast] = useState('');
  const [kind, setKind] = useState('');
  const say = useCallback((m: string, t?: string) => {
    setToast(m); setKind(t || '');
    window.setTimeout(() => setToast(''), 3500);
  }, []);

  const cur = ALL_ITEMS.find((m) => m.key === view) || ALL_ITEMS[0];

  return (
    <div className="lds-root ld-root">
      <div className="lds-wrap">
        <div className="lds-side">
          <div className="lds-brand" onClick={onBack}>
            <div className="b1">💼 영업 DB</div>
            <div className="b2">경정청구 · 인증만료 · 세액감면</div>
          </div>
          <div className="lds-nav">
            {GROUPS.map((g) => (
              <div key={g.name}>
                <div className="lds-ngroup">{g.name}</div>
                {g.items.map((m) => (
                  <div key={m.key} className={'lds-nitem' + (view === m.key ? ' on' : '')} onClick={() => setView(m.key)}>
                    {m.icon} <span>{m.label}</span>
                  </div>
                ))}
              </div>
            ))}
          </div>
          <div className="lds-foot"><button className="lds-homebtn" onClick={onBack}>← 홈으로</button></div>
        </div>
        <div className="lds-main">
          <div className="lds-top"><span className="tt">{cur.title}</span><span style={{ display: 'inline-flex', gap: 6 }}><FlowHelp />{view === 'candidates' && <NightlyToggle onToast={say} />}</span></div>
          <div className="lds-content">
            <div className="lds-head">
              <h2>{cur.label}</h2>
              <div className="desc">{cur.desc}</div>
            </div>
            <div className="lds-card">
              {view === 'capital' && <CapitalPage onToast={say} />}
              {view === 'candidates' && <LeadCandidatePage onToast={say} />}
              {view === 'leads' && <LeadAdminPage onToast={say} />}
              {view === 'fp_portals' && <LeadFpPortalPage onToast={say} />}
              {(view === 'exp_venture' || view === 'exp_mainbiz' || view === 'exp_innobiz') && (
                <CertExpiryPage kind={view === 'exp_venture' ? 'venture' : view === 'exp_mainbiz' ? 'mainbiz' : 'innobiz'} onToast={say} />
              )}
              {view === 'taxcut3y' && <StartupTaxcutPage onToast={say} />}
              {view === 'new_corps' && <NewCorpPage onToast={say} />}
            </div>
          </div>
        </div>
      </div>
      {toast && <div className="lp-toast" style={kind === 'error' ? { background: '#DC2626' } : {}}>{toast}</div>}
    </div>
  );
}
